<template>
  <div class="d-block">
    <div class="d-flex align-items-center justify-content-between">
      <h3 class="my-2">{{ $t('classbook.filters.range_filter_title') }}</h3>
      <b-button v-if="showDeleteBtn"
                variant="transparent"
                data-cy="reset-filter"
                class="primary reset-button"
                @click="resetDate"
      >{{
        $t('classbook.filters.filter_delete_btn')
      }}</b-button>
    </div>
    <div class="d-flex align-items-center justify-content-between pt-1">
      <div class="w-100 mb-2">
        <SDateRangePicker
          v-model="localDate"
          :enable-time-select="!disableTimeFilter"
          :min-date="defaultDate.begins_at"
          :max-date="defaultDate.ends_at"
          @update:model-value="handleUpdate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SDateRangePicker from 'src/components/base/datepicker/SDateRangePicker.vue'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'SduiDateRangeFilter',

  components: {
    SDateRangePicker,
  },

  props: {
    showDeleteBtn: {
      type: Boolean,
      default: true,
    },

    disableTimeFilter: {
      type: Boolean,
      default: false,
    },

    modelValue: {
      type: Object,
      default: () => ({
        begins_at: '',
        ends_at: '',
      }),
    },

    defaultDate: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    showFirst: false,
    showSecond: false,
    localDate: {},
  }),

  computed: {
    models() {
      const { begins_at, ends_at } = this.modelValue
      const { begins_at: beginsAtDate, ends_at: endAtDate } = this.defaultDate

      return {
        begins_at: begins_at || beginsAtDate,
        ends_at: ends_at || endAtDate,
      }
    },

    ends_at() {
      if (this.models.ends_at !== this.defaultDate.ends_at) return this.$dateFormat.dateshort_monthshort(this.models.ends_at)

      return this.$t('classbook.filters.schoolyear_end')
    },

    begins_at() {
      if (this.models.begins_at !== this.defaultDate.begins_at) return this.$dateFormat.dateshort_monthshort(this.models.begins_at)

      return this.$t('classbook.filters.schoolyear_begin')
    },
  },

  emits: ['update:modelValue'],

  methods: {
    handleUpdate({ begins_at, ends_at }) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        begins_at,
        ends_at,
      })
    },

    resetDate() {
      const { begins_at, ends_at } = this.defaultDate

      this.$emit('update:modelValue', {
        ...this.modelValue,
        begins_at,
        ends_at,
      })
    },
  },

  watch: {
    modelValue: {
      handler(newVal, oldVal) {
        if (this.$moment(oldVal?.begins_at).isSame(newVal.begins_at) && this.$moment(oldVal?.ends_at).isSame(newVal.ends_at)) return

        const { begins_at, ends_at } = newVal
        const { begins_at: beginsAtDate, ends_at: endAtDate } = this.defaultDate

        this.localDate = {
          begins_at: begins_at || beginsAtDate,
          ends_at: ends_at || endAtDate,
        }
      },

      immediate: true,
    },
  },
}
</script>
